import React, { useState } from 'react'
import { Container, Header, Title, Action } from './SectionWithActions.styles'
import {
  ConditionalWrapper,
  CopyToClipboard,
  Tooltip,
} from '@sketch/components'

interface ActionProps {
  icon: any
  tooltipText?: string
  onClick: () => void
}

interface SectionWithActionsProps extends React.PropsWithChildren<{}> {
  title: string
  actions?: ActionProps[]
}

export const SectionWithActions = ({
  title,
  actions,
  children,
}: SectionWithActionsProps) => {
  const [tooltipVisibleActionId, setTooltipVisibleActionId] = useState<
    number | undefined
  >(undefined)

  const handleActionClick = (action: ActionProps, id: number) => {
    action.onClick()

    if (!action.tooltipText) return
    setTooltipVisibleActionId(id)

    window.setTimeout(() => {
      setTooltipVisibleActionId(undefined)
    }, CopyToClipboard.animationDuration)
  }

  return (
    <Container>
      <Header>
        <Title>{title}</Title>

        {actions?.map((action, index) => (
          <ConditionalWrapper
            key={`action-${index}`}
            condition={!!action.tooltipText}
            wrapper={children => (
              <Tooltip
                className="tooltip"
                visible={tooltipVisibleActionId === index}
                placement="top"
                content={action.tooltipText}
              >
                {children}
              </Tooltip>
            )}
          >
            <Action onClick={() => handleActionClick(action, index)}>
              {action.icon}
            </Action>
          </ConditionalWrapper>
        ))}
      </Header>
      <div>{children}</div>
    </Container>
  )
}
